module.exports = __webpack_public_path__ + "static/media/trust.8711177f.jpg";